import { IFeedCard } from '../../graphql/types';
import { mockupData } from '../FeedCards/utils';

import definitionCard from '../../studio/assets/feedcardIcons/definitionCard.png';
// import highlightCard from '../../studio/assets/feedcardIcons/highlightCard.png';
import imageCard from '../../studio/assets/feedcardIcons/imageCard.png';
import linkCard from '../../studio/assets/feedcardIcons/linkCard.png';
import profileCard from '../../studio/assets/feedcardIcons/profileCard.png';
// import quoteCard from '../../studio/assets/feedcardIcons/quoteCard.png';
// import listCard from '../../studio/assets/feedcardIcons/listCard.png';
import pollCard from '../../studio/assets/feedcardIcons/pollCard.png';
import videoCard from '../../studio/assets/feedcardIcons/videoCard.png';

export interface ICard {
  title: string;
  mockup: IFeedCard;
  altText: string;
  src: string;
  hintText?: string;
  disabled?: boolean;
  titleNote?: string;
}

export const CardsShowOff: ICard[] = [
  {
    title: 'Image',
    mockup: mockupData.graphic,
    altText: 'Graphic',
    src: imageCard,
    hintText: 'Show your audience what you’re talking about',
  },
  {
    title: 'Text',
    mockup: mockupData.text,
    altText: 'Text',
    src: definitionCard,
    hintText: 'Create text',
  },
  {
    mockup: mockupData.video,
    title: 'Video',
    altText: 'Video',
    src: videoCard,
    hintText: 'Add a YouTube or Vimeo video',
  },
  {
    mockup: mockupData.resource,
    title: 'Link',
    altText: 'Link',
    src: linkCard,
    hintText: 'Link to a relevant article or piece of content',
  },
  // {
  //   mockup: mockupData.quote,
  //   title: 'Quote',
  //   altText: 'Quote',
  //   src: quoteCard,
  //   hintText: 'Attach a quote (from yourself or someone else)',
  // },
  // {
  //   mockup: mockupData.highlight,
  //   title: 'Highlight',
  //   altText: 'Highlight',
  //   src: highlightCard,
  //   hintText: 'Emphasize a point you want your audience to remember',
  // },
  // {
  //   mockup: mockupData.definition,
  //   title: 'Definition',
  //   altText: 'Definition',
  //   src: definitionCard,
  //   hintText: 'Define a word the majority of your audience won’t know',
  // },
  // {
  //   title: 'Activity',
  //   mockup: mockupData.activity,
  //   altText: 'Activity',
  //   src: activity,
  // },
  // {
  //   title: 'Factoid',
  //   mockup: mockupData.factoid,
  //   altText: 'Factoid',
  //   src: factoid,
  // },
  {
    title: 'Profile',
    mockup: mockupData.profile,
    altText: 'Profile',
    src: profileCard,
    hintText: 'Provide more info on a person you’re talking about',
  },
  // {
  //   title: 'List',
  //   mockup: mockupData.list,
  //   altText: 'List',
  //   src: listCard,
  //   hintText: 'List out some key points or steps for your audience to consider',
  // },
  {
    title: 'Poll',
    mockup: mockupData.poll as IFeedCard,
    altText: 'Poll',
    src: pollCard,
  },
  /*{
    title: 'Questionnaire',
    mockup: mockupData.quiz as IFeedCard,
    altText: 'Question',
    src: questionCard,
    disabled: true,
    titleNote: '(Premium feature)',
  },*/
];
